<div class="turnos-wrapper">
  <div class="card glass turnos-card" *ngIf="!cargando; else elseBlock">
    <div class="card-header">
      <span class="mdi mdi-calendar-clock"></span>
      <h3>Seleccionar Fecha y Hora de Retiro/Envío</h3>
    </div>

    <div class="days-list">
      <div class="day-group" *ngFor="let dia of dias[0].categorias; let i = index">
        <h4 class="day-title" (click)="fechaSeleccionada(dia)">
          <span class="mdi mdi-calendar"></span>
          {{dia.nombre}}
        </h4>

        <div class="time-slots-grid" *ngIf="dia.activada">
          <div class="time-slot" 
               *ngFor="let t of newTurnosDisponibles"
               [class.selected]="t.selecionado"
               (click)="onchange($event, t)">
            <span class="mdi" [class.mdi-clock-outline]="!t.selecionado" [class.mdi-check-circle]="t.selecionado"></span>
            <span class="time-text">{{t.dia}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #elseBlock>
    <div class="card glass loading-card" *ngIf="!error; else errorBlock">
      <div class="loading-content">
        <div class="mdi mdi-loading mdi-spin"></div>
        <p>Buscando turnos disponibles...</p>
      </div>
    </div>
  </ng-template>

  <ng-template #errorBlock>
    <div class="card glass error-card">
      <span class="mdi mdi-alert-circle-outline"></span>
      <p>No se encontraron turnos disponibles para esta zona.</p>
    </div>
  </ng-template>
</div>
